import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ApplicationService } from '@core/services/application.service';
import { SessionService } from '@core/session.service';
import { environment } from '@env/environment';
import { TranslateModule } from '@ngx-translate/core';
import { SessionKeyEnum } from '@shared/enums/session.key.enum';
import { UrlParam } from '@shared/enums/url-param.enum';
import { WINDOW } from '@shared/helpers/window.token';
import { StringReplacementPipe } from '@shared/pipes/string-replacement.pipe';
import { StringUtils } from '@shared/utils/string-utils';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-login-with-linkedin-btn',
  templateUrl: './login-with-linkedin-btn.component.html',
  imports: [TranslateModule, StringReplacementPipe],
})
export class LoginWithLinkedinBtnComponent implements OnInit {
  @Input() text = 'Login with LinkedIn';

  @Input() redirectParams: { key: UrlParam; value: string | number }[] = [];

  @Input() assignToOrgId: number;

  @Input() eventHasPayment: boolean;

  @Output() clicked = new EventEmitter();

  tenantName = '';
  environment = environment;

  constructor(
    @Inject(WINDOW) private readonly window: Window,
    private readonly sessionService: SessionService,
    private readonly cookieService: CookieService,
    private readonly applicationService: ApplicationService
  ) {}

  ngOnInit(): void {
    this.tenantName = this.cookieService.get(SessionKeyEnum.TENANT_NAME);
  }

  redirectToLinkedInLoginPage(): void {
    const { origin } = this.window.location;
    const {
      jipUrl: { processToken },
      linkedinConfig: { pathName, clientId, redirectUri },
    } = environment;

    const redirectUrl = new URL(
      `${origin}${this.sessionService.appendLanguagePath(processToken)}`
    );

    const params = new URLSearchParams();

    if (this.redirectParams?.length) {
      for (const { key, value } of this.redirectParams) {
        params.append(key, value.toString());
      }
    }

    // auto assignment param
    if (this.assignToOrgId) {
      params.append(UrlParam.AutoAssignment, this.assignToOrgId.toString());
    }

    redirectUrl.search = params.toString();

    this.applicationService
      .encryptInfo(redirectUrl.toString())
      .subscribe(state => {
        const linkedinUrl = StringUtils.generateLinkedinLoginLink(
          pathName,
          clientId,
          encodeURIComponent(redirectUri),
          state
        );

        this.window.location.href = linkedinUrl;
      });
  }

  emitEvent(): void {
    this.clicked.emit();
  }
}
